// i18n area 'apps' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.pt-PT.meta.json.
import type { enUS } from './apps'

export const ptPT: typeof enUS = {
  apps: {
    title: 'Apps',
    create: 'Criar app',
    createTitle: 'Criar app',
    editTitle: 'Editar app',
    name: 'Nome',
    nameHint: 'DNS-1123, único no scope — imutável após a criação.',
    node: 'Nó',
    nodeHint: 'O nó membro que a serve — placement explícito (o scheduler chega depois).',
    image: 'Imagem',
    editImageHint: 'Uma nova referência volta a resolver-se através do registo OCI — o gesto de pin/rollback.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'O digest só se move sob comando.',
    policyTrackingHint: 'Rolling automático quando um refresh move o branch.',
    archMovePolicy: 'Movimentação cross-arch',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'O que acontece se a app for movida para um nó de outra arquitetura: refuse recusa a movimentação, reresolve volta a resolver o lockfile a partir do branch na arch nova — o conteúdo muda, e a resposta nomeia a mudança de digest.',
    network: 'Rede',
    networkHint: 'Ligação L3 untagged: uma rede lógica de fabric (recomendada — gateway/DNS da sua fonte única), uma overlay, ou um bridge host nu (desaconselhado).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'bridge host:',
    ipAssignment: 'Atribuição de IP',
    ipStatic: 'Estático',
    ipAuto: 'Automático (IPAM)',
    ipAssignmentHint_static: 'É você quem dá o endereço, agora.',
    ipAssignmentHint_auto: 'O IPAM escolhe um endereço livre nos ranges da rede reservados ao TVirt.',
    bridgeDiscouraged: 'Bridge host nu — DESACONSELHADO: o TVirt não sabe nada do seu endereçamento, por isso gateway e DNS têm de ser dados à mão. A via recomendada é uma rede lógica de fabric.',
    ip: 'IP',
    ipHint: 'IPv4 estático dentro da subnet da ligação.',
    ipCidrHint: 'Em forma CIDR num bridge nu (ex. 192.168.1.10/24) — não há de onde derivar o prefixo.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manual — um bridge nu não deriva nada.',
    dnsServers: 'Servidores DNS',
    dnsManualHint: 'Manuais, separados por vírgula — pelo menos um.',
    rootKind: 'Root',
    rootEphemeral: 'efémera',
    rootPersistent: 'persistente',
    rootEphemeralHint: 'Recriada a partir da imagem a cada recriação; vive no storage efémero de cluster.',
    rootEphemeralHintNamed: 'Recriada a partir da imagem a cada recriação; vive no storage efémero de cluster ({name}).',
    rootPersistentHint: 'Sobrevive aos reinícios; vive no storage que escolher.',
    rootStorage: 'Storage da root',
    editRootStorageHint: 'A root volta a renderizar-se no novo pool — os dados existentes NÃO se movem sozinhos.',
    volumes: 'Volumes',
    volumeAdd: 'Adicionar volume',
    volumeName: 'Nome',
    volumeMountPath: 'Caminho de mount',
    volumeKind: 'Tipo',
    volumeStorage: 'Storage',
    devices: 'Dispositivos',
    deviceClassHint: 'Pede-se uma CLASSE (uma etiqueta gpu-device ou usb-device), nunca um dispositivo concreto: o nó declarado tem de ter um marcado para as Apps. Várias Apps podem usar o mesmo dispositivo — um contentor partilha-o, não o retira ao anfitrião.',
    deviceSlot: 'Slot',
    deviceTag: 'Etiqueta',
    deviceValue: 'Classe',
    deviceUnresolved: 'neste momento nada é resolvido',
    noDeviceTags: 'Ainda não há nenhuma etiqueta do tipo gpu-device ou usb-device: cria uma e atribui-a aos dispositivos marcados para as Apps.',
    env: 'Ambiente',
    envHint: 'Uma CHAVE=valor por linha.',
    secretEnvTitle: 'Variáveis secretas',
    secretEnvNotice: 'Um valor secreto nunca mais volta da API: ninguém o volta a ler, nem sequer quem o escreveu. No checkpoint viaja selado com a masterpass, por isso um restauro sem a masterpass pedirá para o escrever de novo.',
    secretEnvPromote: 'Torne secreta uma das variáveis escritas acima:',
    secretEnvAdd: 'Adicionar variável secreta',
    secretEnvName: 'Nome',
    secretEnvValue: 'Valor',
    secretEnvKept: 'conservado — deixe vazio para não o alterar',
    secretEnvWithdrawWarning: 'Para deixar de tratar como secreta uma variável que já o é, escreva-lhe um valor novo: retirar apenas a marca seria uma forma de LER o que não sai do store. Removê-la, pelo contrário, apaga-a.',
    secretEnvChip: 'secreto',
    startNow: 'Iniciar já (caso contrário a app nasce parada)',
    deletePersistentIntro: 'Esta app tem dados persistentes — escolha o que fazer com eles:',
    deleteKeepData: 'Manter os dados (os diretórios ficam nos seus storages, órfãos)',
    deletePurgeData: 'Eliminar também os dados',
    phase: 'Fase',
    phase_running: 'Em execução',
    phase_stopped: 'Parada',
    phase_error: 'Erro',
    phase_unknown: 'Desconhecida',
    desiredState: 'Pretendido',
    wantedRunning: 'em execução',
    wantedStopped: 'parada',
    start: 'Iniciar',
    stop: 'Parar',
    restart: 'Reiniciar',
    refreshImage: 'Atualizar imagem (adotar o novo @current)',
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Nenhum output capturado.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'A App não está em execução — uma shell precisa de um contentor vivo. Os seus logs leem-se em qualquer estado.',
    shellConnect: 'Ligar',
    shellDisconnect: 'Desligar',
    shellExited: 'A sessão terminou com código de saída {code}.',
    shellEndedWithoutStatus: 'A sessão terminou sem um estado de saída: {reason}',
    shellRevoked: 'O ticket da sessão já não é válido — expirou, ou o início de sessão que o abriu foi revogado.',
    shellHint: 'Clica no quadro preto e escreve: as teclas chegam ao contentor. Ctrl+C e as setas funcionam; exit fecha a shell.',
    shellStatus: {
      connecting: 'A ligar…',
      connected: 'Ligada',
      ended: 'Terminada'
    },
    deleteRunningError: '{name} está pretendida em execução — pare-a primeiro.',
    tabs: {
      general: 'Geral',
      image: 'Imagem',
      network: 'Rede',
      storage: 'Storage',
      devices: 'Dispositivos',
      observed: 'Observado'
    },
    attachment: 'Ligação',
    runningDigest: 'Digest em execução',
    lastError: 'Último erro',
    reportObservedAt: 'Último report do worker',
    desiredStateLock: 'Governado pelas ações Iniciar/Parar — nunca uma edição direta.',
    ipEditDisabledHint: 'Editável apenas com atribuição estática.',
    derivedFromNetworkHint: 'Derivado da fonte única da rede — manual apenas num bridge nu com IP estático.',
    ephemeralUnset: 'não configurado',
    ephemeralMissing: 'O storage efémero das Apps não está configurado — criar uma app com partes efémeras (root ou volumes) é recusado até o definir.',
    ephemeralCurrent: 'Storage efémero das Apps: {name}',
    ephemeralMissingCreate: 'Esta app tem partes efémeras mas o storage efémero das Apps não está definido — a criação será recusada. Defina-o primeiro no banner da página Apps.',
    setEphemeral: 'Definir storage efémero',
    changeEphemeral: 'Mudar storage efémero',
    setEphemeralTitle: 'Definir o storage efémero das Apps',
    changeEphemeralTitle: 'Mudar o storage efémero das Apps',
    ephemeralStorageHint: 'DEFAULT de cluster: o pool dir-like onde vivem as roots e os volumes efémeros de cada app, salvo override declarado pela app. Uma mudança não é a quente e não reinicia nada: vale a partir do próximo start de cada app — os dados efémeros não se movem.',
    ephemeralPool: 'Pool de storage',
    ephemeralOverride: 'Storage efémero (override por app)',
    ephemeralOverrideInherit: 'Herdar o default de cluster',
    ephemeralOverrideInheritNamed: 'Herdar o default de cluster ({name})',
    ephemeralOverrideHint: 'Pool por app para a root e os volumes efémeros — deixe vazio para herdar o default de cluster. Mudá-lo não é a quente e não reinicia nada: vale a partir do próximo start (dados efémeros renascidos vazios no novo pool) e requer a permissão app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Todos os branches',
    imageBranchHint: 'Restringe as imagens às que este branch nomeia; sem branch veem-se todas as do repositório.',
    imageDigestHint: 'O conteúdo: escolhe-se da tabela de digests, que traz a sua proveniência e a sua arquitetura. O mesmo branch oferece um por arquitetura, e não são intercambiáveis.',
    imageLockfile: 'Referência resolvida',
    imageNoImages: 'Nenhuma imagem em cache para este repositório — descarrega uma a partir de Imagens OCI.',
    imageHeadNotCached: 'não está em cache — descarregado no arranque',
    imageNoRegistries: 'Nenhum repositório registado: regista um para poderes escolher uma imagem.',
    imageChosenHint: 'A imagem escolhe-se na cascata do diálogo de edição: a referência nunca se escreve à mão.',
    registerRepositoryHint: 'Registar não descarrega nada: torna um repositório observável, para que a imagem se escolha sem sair deste diálogo.',
    registerRepositoryBranchHint: 'Facultativo: o primeiro branch a observar (p. ex. latest).',
    registerRepositoryElsewhere: 'O repositório que procuras não está registado: o registo faz-se na secção Imagens OCI, por quem tiver a permissão.'
  },
  cts: {
    createAction: 'Criar CT',
    createTitle: 'Criar um container a partir de um template',
    createError: 'O container não foi criado',
    template: 'Template CT',
    noTemplates: 'Nenhum template CT — importe um em Templates CT',
    resources: 'Recursos',
    node: 'Nó',
    phase: {
      defined: 'Nunca ligado',
      materializing: 'Em materialização',
      ready: 'Pronto',
      starting: 'A iniciar',
      running: 'Em execução',
      stopping: 'A parar',
      stopped: 'Parado',
      deleting: 'Em eliminação',
      error: 'Em erro'
    },
    actions: {
      start: 'Iniciar',
      stop: 'Parar',
      restart: 'Reiniciar',
      markTemplate: 'Promover a template CT',
      error: 'A ação foi recusada'
    },
    markTemplate: {
      confirmTitle: "Promover '{name}' a template CT?",
      confirmBody: 'O container sai desta lista e passa para os Templates CT, pronto de imediato a gerar novos CTs. Os metadata continuam editáveis, e pode voltar a torná-lo um CT em qualquer momento.',
      confirm: 'Promover',
      moved: "'{name}' agora é um template CT — encontra-o em Templates CT."
    },
    stopCause: {
      api: 'Parado via TVirt',
      'ct-exit': 'O container saiu por si próprio',
      'host-reboot': 'Morreu com o reinício do nó',
      'start-failed': 'O arranque falhou — o erro da task diz o que falta e como se resolve'
    },

    console: 'Consola',
    consoleUnavailable: 'O container não está em execução — uma consola precisa de um container vivo. Os seus logs, esses, leem-se em qualquer estado.',
    consoleNoTemplate: 'Um template nunca corre, por isso não tem consola: crie um CT a partir dele e abra a desse.',
    consoleConnect: 'Ligar',
    consoleDisconnect: 'Desligar',
    consoleReconnect: 'Voltar a ligar',
    consoleTakenBy: 'Outro operador tomou esta consola ({user}). Uma consola por container: voltar a ligar traz-lha de volta.',
    consoleHint: 'Clique no retângulo preto e escreva: as teclas chegam ao container. Ctrl+C e as setas funcionam.',
    consoleEndpointDown: 'O ponto de acesso da consola não abre no nó que serve o container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'O container não está em execução — uma shell precisa de um container vivo. Os seus logs leem-se em qualquer estado.',
    shellNoTemplate: 'Um template nunca corre, por isso não tem shell: cria um CT a partir dele e abre a dele.',
    shellConnect: 'Ligar',
    shellDisconnect: 'Desligar',
    shellExited: 'A sessão terminou com código de saída {code}.',
    shellEndedWithoutStatus: 'A sessão terminou sem um estado de saída: {reason}',
    shellRevoked: 'O ticket da sessão já não é válido — expirou, ou o início de sessão que o abriu foi revogado.',
    shellHint: 'Clica no quadro preto e escreve: as teclas chegam ao contentor. Ctrl+C e as setas funcionam; exit fecha a shell.',
    shellStatus: {
      connecting: 'A ligar…',
      connected: 'Ligada',
      ended: 'Terminada'
    },
    rootPassword: 'Palavra-passe de root',
    rootPasswordHint: 'Escrita uma vez no rootfs copiado (como hash, nunca mais mostrada). As imagens das distribuições não trazem palavra-passe de root: sem ela, a shell é a única entrada.',
    sshKeys: 'Chaves SSH públicas de root',
    sshKeysHint: 'Uma chave pública OpenSSH por linha, em root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'A ligar…',
      connected: 'Ligada',
      reconnecting: 'A voltar a ligar…'
    },
    logs: 'Logs',
    logsTitle: 'Logs',
    logsEmpty: 'Nenhum output capturado.',
    logsSource: 'Que log',
    logsSourceConsole: 'A consola do init do container — porque o serviço lá dentro não arrancou',
    logsSourceSupervisor: 'O supervisor liblxc — porque o container nunca chegou a arrancar',
    logsNeverStarted: 'Nunca foi iniciado, por isso ainda não há nada registado — inicie-o, e os logs lá estarão mesmo que o arranque falhe.',
    logsNoTemplate: 'Um template nunca corre, por isso nunca registou nada.',
    logsError: 'Os logs não foram capturados',

    tabs: {
      general: 'Geral',
      hardware: 'Hardware',
      network: 'Rede',
      provenance: 'Proveniência'
    },
    templateFlag: 'Template CT',
    templateLock: 'Só muda com as ações Promover / Voltar a CT — nunca uma edição direta.',
    sourceLock: 'Proveniência, registada à nascença — nunca reescrita; uma origem morta deixa a referência nua.',
    storageLock: 'Fixado na criação — mover o rootfs é um round futuro.',
    startedAt: 'Iniciado',
    lastStop: 'Última paragem',
    editNicsTitle: 'Editar redes',
    nicDisconnected: 'desligada'
  },
  ctTemplates: {
    title: 'Templates CT',
    importAction: 'Importar do catálogo',
    importTitle: 'Importar template CT do catálogo',
    importSubmit: 'Importar',
    importError: 'O import foi recusado',
    importHint: 'Materializar copia o rootfs para o storage escolhido — o ficheiro de catálogo fica intacto. Para adicionar novos ficheiros, carregue-os primeiro dentro de um catálogo.',
    sourceFile: 'Ficheiro de template CT',
    sourceFileHint: 'Os ficheiros ct-rootfs do catálogo escolhido, apenas os prontos',
    noFiles: 'Nenhum ficheiro ct-rootfs pronto neste catálogo — carregue um a partir da página do catálogo',
    source: 'Ficheiro de origem',
    rootfsStorage: 'Storage do rootfs',
    rootfsStorageHint: "Onde vive a árvore rootfs extraída — um storage com filesystem e espaço livre suficiente para o tamanho extraído mais cerca de 1 GiB de margem (caso contrário, o import falha).",
    resources: 'Recursos',
    cores: 'vCPU',
    memoryMiB: 'Memória (MiB)',
    cpuLimit: 'Limite de CPU',
    cpuLimitHint: 'Equivalentes de cores do host (ex. 1.5); vazio = sem teto',
    cpuUncapped: 'sem teto',
    cpuWeight: 'Peso de CPU',
    hostname: 'Hostname',
    hostnameHint: 'Vazio = o nome do próprio CT',
    nameservers: 'Nameservers DNS',
    dnsHint: 'Separados por vírgula; vazio = herda os do host',
    searchDomains: 'Domínios de pesquisa DNS',
    dnsInherited: 'Herdado do host',
    networks: 'Redes',
    nicSlot: 'Slot NIC',
    phase: {
      materializing: 'Em materialização',
      ready: 'Pronto',
      deleting: 'Em eliminação',
      error: 'Erro'
    },
    exportAction: 'Exportar para o catálogo',
    exportTitle: 'Exportar para o catálogo',
    exportSubmit: 'Exportar',
    exportError: 'O export foi recusado',
    exportHint: 'Empacota o rootfs materializado num NOVO ficheiro ct-rootfs no catálogo escolhido — o template fica intacto.',
    exportName: 'Nome do ficheiro',
    exportNameHint: 'Vazio = <template>-export-<n>',
    markCt: {
      action: 'Voltar a CT',
      confirmTitle: "Voltar a tornar '{name}' um CT?",
      confirmBody: 'O template sai desta lista e volta para a lista de CTs, de novo iniciável. Enquanto não o promover de novo, não se podem criar CTs a partir dele.',
      confirm: 'Voltar a CT',
      moved: "'{name}' é de novo um CT — encontra-o na lista de CTs."
    }
  },
  oci: {
    registriesTitle: 'Registries OCI',
    imagesTitle: 'Imagens OCI',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Genérico',
    providerImmutableHint: 'O provider é imutável depois da criação — um provider diferente é um novo registry.',
    url: 'URL',
    urlHintPreset: 'Pré-preenchido pelo provider — substitua apenas para mirrors.',
    urlHintRequired: 'Obrigatório para os registries genéricos: o URL base https://.',
    urlHintEcr: 'Obrigatório: os endpoints ECR são por conta/por região — não existe preset.',
    credential: 'Credencial',
    credentialNone: 'Acesso anónimo',
    credentialHint: 'Uma entrada de keystore utilizador-e-palavra-passe; os workers resolvem-na no momento do uso — nunca ficheiros de auth por nó.',
    nameHint: 'Nome tipo host (docker.io, registry.intra); único por scope, imutável',
    addRegistry: 'Adicionar registry',
    addRegistryTitle: 'Adicionar registry OCI',
    verify: 'Verificar',
    verifyState: 'Verificação',
    verified: 'Verificado',
    verifyFailed: 'Falhada',
    neverVerified: 'Nunca verificado',
    registryInUseError: "'{name}' ainda tem repositórios registados — elimine-os primeiro.",
    repositories: 'Repositórios',
    repositoriesHint: 'Registar observa os branches (tags OCI) — não transfere nada. O refresh resolve cada branch observado e mantém o reflog.',
    noRepositories: 'Nenhum repositório registado neste registry.',
    registerRepository: 'Registar repositório',
    repoPath: 'Caminho',
    repoPathHint: "Caminho do repositório no registry, ex. 'example' ou 'library/nginx'",
    branches: 'Branches',
    branchesHint: 'Branches observados (tags OCI), separados por vírgula — ex. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Resolvido AGORA: o pull transfere o digest para onde o branch aponta hoje.',
    refresh: 'Atualizar',
    deleteRepository: 'Eliminar repositório',
    reflogCount: '{n} anteriores',
    noResolutions: 'Nunca atualizado — nenhuma resolução observada.',
    refreshFailed: 'Última atualização falhada ({when})',
    loadError: 'Impossível carregar os repositórios.',
    reference: 'Referência',
    digest: 'Digest',
    digestHint: 'sha256:… — a imagem exata, sem branch (detached)',
    size: 'Tamanho',
    nodes: 'Nós',
    detached: 'detached',
    detachedHint: 'Transferida por digest, sem branch — o controlo de drift não se aplica.',
    pulledAt: 'Transferida',
    pull: 'Pull',
    pullTitle: 'Pull de imagem',
    pullHint: 'Pre-warming, nunca um pré-requisito: um pull por branch resolve AGORA e transfere ESSE digest; um pull por digest é detached.',
    pullError: 'O pull foi recusado',
    pullMode: 'Pull por',
    pullModeBranch: 'Branch (resolver agora)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'O default honesto: como apt install, reexecutado mais tarde pode dar uma imagem diferente.',
    pullModeDigestHint: 'Digest exato — reprodutibilidade e rollback; renuncia ao controlo de drift.',
    importFromRegistry: 'Importar do registry',
    importFromCatalog: 'Importar do catálogo',
    importCatalogTitle: 'Importar imagem OCI do catálogo',
    importCatalogHint: 'A via air-gapped: um arquivo oci-image pronto (tar/tar.gz — docker-archive ou oci-archive) é materializado no store de imagens com a referência catalog/<catálogo>/<file>@<digest>; as apps consomem-no como qualquer outra imagem. Os arquivos carregam-se nos catálogos — esta secção só importa.',
    importCatalogFile: 'Arquivo',
    importCatalogFileHint: 'Os ficheiros oci-image prontos do catálogo escolhido.',
    importCatalogNoFiles: 'Nenhum arquivo oci-image pronto neste catálogo — carregue um a partir do detalhe do catálogo.',
    importCatalogError: 'O import foi recusado',
    registry: 'Registry',
    repository: 'Repositório',
    cacheMissing: 'A cache OCI de cluster não está configurada — os pulls são recusados até definir um pool de storage.',
    setCache: 'Definir cache',
    setCacheTitle: 'Configurar a cache OCI',
    setCacheHint: 'O pool DEFAULT ao nível do cluster que aloja os blobs das imagens transferidas — um scope pode fazer override com o seu próprio pool (página Scopes). Mudá-lo não é a quente e não reinicia nada, e não move os blobs: reaparecem lazy no próximo start/uso.',
    cachePool: 'Pool de storage',
    changeCache: 'Mudar cache',
    changeCacheTitle: 'Mudar o pool da cache OCI',
    cacheCurrent: 'Cache OCI do cluster (default): {name}',
    sectionOverview: 'Vista geral',
    sectionRepositories: 'Repositórios',
    sectionExplore: 'Explorar',
    exploreHint: 'Pesquisa remota ao vivo no registry — Docker Hub completa (descrição, downloads, estrelas), outros providers best-effort. Selecione um resultado para ler a descrição completa e percorrer as suas tags remotas; a partir de uma tag pode adicionar a referência a um repositório TVirt.',
    exploreSearch: 'Pesquisar',
    exploreUnsupported: 'Este provider não suporta a pesquisa.',
    exploreNoResult: 'Nenhum repositório correspondente.',
    exploreNoTags: 'Nenhuma tag correspondente neste repositório.',
    exploreOfficial: 'Oficial',
    explorePulls: 'Downloads',
    exploreStars: 'Estrelas',
    exploreUpdated: 'Atualizado {when}',
    exploreLoadMore: 'Carregar mais',
    exploreSelectHint: 'Selecione um resultado: a descrição completa e as tags remotas carregam-se aqui.',
    exploreNoDescription: 'Nenhuma descrição disponível deste provider.',
    exploreTagsTitle: 'Tags remotas',
    exploreTagFilter: 'Pesquisar tags',
    exploreAddToRepo: 'Adicionar a repositório',
    exploreAdded: '{path}:{tag} é agora seguido — veja a secção Repositórios.',
    addBranch: 'Adicionar branch',
    purgeRequiredTitle: "Eliminar '{name}' e as suas imagens?",
    purgeRequiredBody: 'Nenhuma app consome este repositório, mas ainda existem imagens descarregadas: eliminá-lo remove também os seus registos, e os blobs em cache passam ao garbage collector.',
    purgeConfirm: 'Eliminar também as imagens',
    providerSelectHint: 'Selecione o tipo de registry: o cartão conta o preset e o uso.',
    providerDesc: {
      dockerhub: 'O registry público do Docker: URL pré-preenchido, pesquisa completa com descrições e contagens.',
      ghcr: 'GitHub Container Registry: URL pré-preenchido; as contas usam um personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpoints por conta/por região — o URL tem de ser indicado.',
      quay: 'O registry Red Hat Quay: URL pré-preenchido.',
      generic: 'Registry self-hosted (Harbor, registry:2, …): o URL https:// é obrigatório.'
    },
    layerCount: 'Layers',
    verifiedAt: 'Última verificação',
    verifyOk: 'Resultado',
    verifyMessage: 'Mensagem de verificação',

    // O modelo #348/R39: a imagem É o digest — o conteúdo — e registry, repositório e branch são os NOMES que lhe chegam.
    head: 'Head',
    heads: 'Cabeças por arquitetura',
    listDigest: 'Digest da lista',
    neverResolved: 'Nunca resolvido',
    totalSize: 'Tamanho total',
    reflogTitle: 'Histórico de resoluções',
    usedBy: 'Usado por',
    usageLockfile: 'lockfile',
    usageRunning: 'em execução',
    evictable: 'despejável',
    evict: 'Despejar da cache',
    evictHeadTitle: 'Despejar {digest}?',
    evictHeadBody: 'É a resolução atual de pelo menos um coletor: despejá-lo é legítimo — é só cache, o branch remoto continua a servi-lo — mas não deve acontecer por engano. O blob é UM: o despejo esvazia todos os coletores que o partilham.',
    evictConfirm: 'Despejar mesmo assim',

    arch: 'Arquitetura',
    names: 'Nomes',
    noNames: 'sem nome',
    views: 'Vistas',
    lastView: 'última vista',
    evictLastViewTitle: 'Remover a última referência a {digest}?',
    evictLastViewBody: 'É a última vista sobre este conteúdo: ao removê-la a imagem deixa de existir no TVirt e os bytes ({size}) são libertados. É o docker image rm do modelo — não um efeito secundário, a própria operação.',
    branchesTabHint: 'Os branches observados deste repositório: de cada um as cabeças de hoje — uma por arquitetura — a cronologia dos refrescos e quantas das imagens que nomeou estão em cache. O refresco é o «git fetch» do repositório: resolve todos os seus branches de uma vez.',
    noBranches: 'Nenhum branch observado neste repositório.',
    stopObserving: 'Deixar de observar o branch',
    pullBranch: 'Descarregar para a cache a cabeça do branch (o refresh resolve, este descarrega)',
    pullDigest: 'Descarregar este digest para a cache',
    imageCount: 'Imagens',
    deleteBranchPurgeTitle: 'Deixar sem nome as imagens de {name}?',
    deleteBranchPurgeBody: 'Nenhuma app nomeia este branch, mas algumas imagens só são alcançadas por ele: ao eliminá-lo ficam em cache sem nome, listadas entre as imagens do repositório e removíveis à mão.',
    deleteBranchPurgeConfirm: 'Eliminar e deixar as imagens sem nome',
    imagesTabHint: 'As imagens deste repositório — os conteúdos, ou seja os digests — visíveis mesmo sem escolher um branch. Uma imagem é única por cluster: os nomes que lhe chegam podem ser vários.',
    noImages: 'Nenhuma imagem deste repositório está materializada em cache.',
    deleteRepositoryTitle: 'Eliminar {name}?',
    deleteRepositoryBody: 'Desaparecem o repositório e os seus branches, com a sua cronologia. As imagens ficam em cache: perdem apenas este nome. Um repositório nomeado por uma app não se elimina.',
    provenanceCatalog: 'catálogo',
    refreshedAt: 'Atualizado',
    neverRefreshed: 'Nunca atualizado',
    sectionBranches: 'Branches',
    sectionImages: 'Imagens',
    repositoriesGovernedElsewhere: 'Aqui os repositórios apenas se consultam: registá-los, atualizá-los, observar os seus branches e remover as suas imagens faz-se na secção Imagens OCI.',
    gotoImages: 'Ir para Imagens OCI'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Contentores',
    instances: 'Instâncias',
    instancesTooltip: '{running} em execução, {error} com erro',
    placement: 'Colocação',
    spread: 'distribuição',
    ha: 'HA',
    templateRevision: 'revisão',
    deleting: 'A eliminar',
    empty: 'Nenhum pod — crie uma app (um contentor) ou um pod a partir da CLI (create-pod).',
    openInstances: 'Abrir as instâncias',
    rollingRestart: 'Reinício progressivo',
    scale: 'Escalar',
    scaleTitle: 'Escalar {name}',
    scaleHint: 'Número de instâncias (0–64): para cima nasce o ordinal livre mais baixo, para baixo retira-se o mais alto e os seus dados persistentes ficam.',
    scaleError: 'A escala falhou',
    replicas: 'Réplicas',
    deleteRunningError: '{name} está em execução — pare-o primeiro.',
    deleteInstancesIntro: 'Todas as {count} instâncias serão removidas.',
    stateRunning: 'Em execução',
    stateStopped: 'Parado',
    editor: {
      createTitle: 'Criar Pod',
      create: 'Criar Pod',
      editTitle: 'Editar Pod',
      nameHint: 'DNS-1123, no máximo 58 caracteres — as instâncias chamam-se <nome>-<índice>; imutável após a criação.',
      restartPolicy: 'Política de reinício',
      restartPolicyHint_always: 'O nó reinicia qualquer contentor que tenha saído, com backoff exponencial (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Só um contentor que sai com código diferente de zero é reiniciado; a saída 0 fica em repouso.',
      restartPolicyHint_never: 'Um contentor que saiu fica como está — a instância termina succeeded ou failed.',
      grace: 'Tolerância (s)',
      graceHint: 'O limite SIGTERM → SIGKILL de uma paragem.',
      hostname: 'Nome do anfitrião',
      hostnameHint: 'Vazio = o nome da instância.',
      hostnameDefault: 'o nome da instância',
      sharePid: 'Partilhar o namespace PID entre os contentores',
      containersIntro: 'Os contentores init correm até ao fim, por ordem, antes de os contentores arrancarem; os contentores partilham a rede da instância (um IP, localhost entre eles).',
      initContainers: 'Contentores init',
      initAdd: 'Adicionar contentor init',
      initHint: 'Cada um deve sair com 0; uma falha coloca a instância em erro e o nó tenta de novo com backoff.',
      containerAdd: 'Adicionar contentor',
      atLeastOne: 'Um Pod precisa de pelo menos um contentor.',
      duplicateNames: 'Os nomes dos contentores têm de ser únicos no Pod (contentores init incluídos).',
      containerName: 'Nome do contentor',
      containerInvalid: 'Este contentor está incompleto: nome (DNS-1123), imagem, montagens em volumes declarados, limites e sonda numéricos.',
      command: 'Comando',
      commandHint: 'Substitui o entrypoint da imagem — um argumento por linha, nunca uma string de shell.',
      args: 'Argumentos',
      argsHint: 'Um por linha (o CMD da imagem se vazio).',
      mounts: 'Montagens',
      mountAdd: 'Adicionar montagem',
      mountNoVolumes: 'Declare primeiro um volume no separador Armazenamento.',
      readOnly: 'só de leitura',
      resources: 'Limites',
      cpus: 'CPUs',
      cpusHint: 'podman --cpus (p. ex. 1.5)',
      memory: 'Memória (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonda de vitalidade',
      healthCmd: 'Comando da sonda',
      healthCmdHint: 'Executado dentro do contentor pelo nó a cada tick de supervisão — um argumento por linha; saída 0 = saudável.',
      healthTimeout: 'Tempo limite (s)',
      healthRetries: 'Tentativas',
      healthRetriesHint: 'Falhas consecutivas antes de o nó reiniciar o contentor.',
      ips: 'Endereços estáticos',
      ipsHint: 'Um por instância, por ordem ordinal — uma escala além da lista é recusada.',
      instance: 'instância',
      volumesHint: 'Os volumes são do Pod; o caminho de montagem é de cada contentor (separador Contentores).',
      spread: 'Distribuição',
      spreadHint_preferred: 'Instâncias em nós diferentes quando possível.',
      spreadHint_required: 'Instâncias em nós diferentes, ou a escala recusa.',
      spreadHint_none: 'Só o decisor.',
      ha: 'Alta disponibilidade (opt-in)',
      haHint: 'Cada peça persistente em storage partilhado; se o nó morrer, o decider HA recria as instâncias noutro membro (failover automático, como as VM HA).',
      yes: 'sim',
      no: 'não'
    },
    detail: {
      container: 'Contentor',
      actions: 'Ações',
      ready: 'Pronto',
      notReady: 'Não pronto',
      restarts: 'Reinícios',
      lastRestartAt: 'Último reinício:',
      backoffUntil: 'Nova tentativa às',
      stateAbsent: 'ausente',
      stateRunning: 'em execução',
      stateTerminated: 'terminado',
      stateWaiting: 'em espera',
      init: 'init',
      noInstances: 'Sem instâncias (réplicas 0).',
      ha: 'HA',
      haHint: 'Failover automático: se o nó morrer, o decider HA recria a instância noutro membro (cada peça persistente em storage partilhado).',
      authority: 'Authority (nó)',
      homeless: 'sem authority',
      homelessHint: 'Um restauro a partir de checkpoint deixa a authority de fora (#380): nenhum nó a serve até escalar o Pod (mesmo para o mesmo número de réplicas).',
      restartContainer: 'Reiniciar só este contentor (o pod fica de pé)',
      divergingHint: 'O estado desejado desta instância diverge do predefinido do Pod (PD-P19).',
      revisionLag: 'revisão {applied} aplicada de {current}',
      updatedInstances: '{updated}/{desired} instâncias nesta revisão'
    }
  }
}
